import { css } from "@emotion/css";
import { space } from "@octopusdeploy/design-system-tokens";
import React from "react";
import { BranchSelector } from "~/areas/projects/components/BranchSelector/BranchSelector";
import { ProjectCreatePullRequestLink } from "~/areas/projects/components/ProjectCurrentBranchDisplay/ProjectCreatePullRequestLink";
import { useIsPageVersionControlled } from "~/areas/projects/context/useIsPageVersionControlled";
export function ProjectPageTitleAccessory() {
    const isVersionControlled = useIsPageVersionControlled();
    if (!isVersionControlled) {
        return null;
    }
    return <PageHeaderBranchSelector />;
}
function PageHeaderBranchSelector() {
    return (<div className={branchSelectorContainer}>
            <BranchSelector />
            <ProjectCreatePullRequestLink />
        </div>);
}
const branchSelectorContainer = css({
    display: "flex",
    gap: space["16"],
    alignItems: "center",
});
